var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49297 11.8781C5.08047 11.8781 3.12109 9.92188 3.12109 7.50625C3.12109 5.79375 4.11484 4.26875 5.61797 3.55625V2.20625C3.41172 2.98438 1.87109 5.0875 1.87109 7.50625C1.87109 10.6094 4.38672 13.125 7.48984 13.125C9.90859 13.125 12.0117 11.5844 12.7898 9.37813H11.4398C10.7273 10.8813 9.20234 11.875 7.48984 11.875L7.49297 11.8781ZM14.3742 8.13125L14.2211 8.88125C13.5773 12.0594 10.7711 14.375 7.48984 14.375C3.69609 14.375 0.621094 11.3 0.621094 7.50625C0.624219 4.225 2.94297 1.42188 6.11797 0.778125L6.86797 0.625V4.41563L6.45234 4.5625C5.21484 5 4.37109 6.17188 4.37109 7.50625C4.37109 9.23125 5.76797 10.6281 7.49297 10.6281C8.82734 10.6281 9.99922 9.78438 10.4367 8.54688L10.5836 8.13125H14.3742Z",
    fill: "#7B7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7937 5.62813C12.2312 4.03438 10.9656 2.76875 9.37187 2.20625V3.55312C10.2812 3.98438 11.0156 4.71875 11.4469 5.62813H12.7937ZM10.4406 6.45937C10.1281 5.575 9.425 4.87187 8.54062 4.55938L8.125 4.4125V0.625L8.87187 0.778125C11.5594 1.325 13.6781 3.44063 14.2219 6.12813L14.375 6.875H10.5875L10.4406 6.45937Z",
    fill: "#7B7B7B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.1cc8de36.svg";
export { ForwardRef as ReactComponent };